import React, { useEffect } from "react";

import HomeFooter from "../HomePage/HomeFooter";
import FSNavigation from "../FSApp/FSNavigation";

const TermsOfUse = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Uvjeti Korištenja - FucaScore";
  }, []);

  return (
    <>
      <FSNavigation />
      <div className="scorify-app privacy-terms">
        <button className="back-btn" onClick={() => window.history.back()}>
          ⬅ Povratak
        </button>
        <main className="scorify-main">
          <div className="policy-glass-card">
            <h1>Uvjeti korištenja</h1>
            <p className="last-updated">Zadnja izmjena: Srpanj, 2026.</p>

            <section>
              <h2>1. Opće odredbe</h2>
              <p>
                Korištenjem ove platforme pristajete na ove Uvjete korištenja.{" "}
                <strong>FucaScore</strong> služi kao digitalna platforma i alat
                namijenjen organizatorima, sudionicima i posjetiteljima za
                praćenje rezultata, rasporeda i statistika malonogometnih
                turnira i liga.
              </p>
            </section>

            <section>
              <h2>2. Točnost informacija</h2>
              <p>
                Organizacijski odbori i administratori pojedinih turnira ulažu
                maksimalne napore kako bi podaci na platformi bili točni i
                pravovremeni. Ipak, zadržavamo pravo na pogreške pri unosu ili
                izmjene rasporeda u zadnji trenutak zbog više sile (vremenske
                prilike, tehnički problemi). Službeni podaci zapisnika utakmice
                imaju prednost nad podacima u aplikaciji.
              </p>
            </section>

            <section>
              <h2>3. Ponašanje korisnika</h2>
              <p>
                Zabranjeno je svako neovlašteno pokušavanje pristupa
                administraciji aplikacije, manipulacija podacima ili korištenje
                automatiziranih sustava (botova) za preopterećenje ili
                prikupljanje podataka s ove platforme.
              </p>
            </section>

            <section>
              <h2>4. Pravo na izmjene</h2>
              <p>
                Organizatori turnira zadržavaju pravo izmjene pravila
                natjecanja, sustava igranja te diskvalifikacije ekipa koje se ne
                pridržavaju sportskog kodeksa. Sve obavijesti objavljene unutar
                platforme smatraju se važećima za sudionike.
              </p>
            </section>

            <section>
              <h2>5. Ograničenje odgovornosti</h2>
              <p>
                FucaScore i njegovi administratori se odriču odgovornosti za
                bilo kakvu štetu nastalu oslanjanjem isključivo na informacije
                iz aplikacije u situacijama koje zahtijevaju fizičku prisutnost
                na terenu (npr. promjena satnice utakmice u zadnji tren).
              </p>
            </section>

            <section>
              <h2>6. Prikaz podataka i privatnost</h2>
              <p>
                Podaci o strijelcima i igračima mogu se prikazivati u skraćenom
                obliku (npr. ime i inicijal prezimena) u svrhu zaštite
                privatnosti, uz istovremeno osiguravanje sportske
                transparentnosti. Imena ekipa i sponzora javni su podaci
                natjecanja.
              </p>
            </section>

            <section>
              <h2>7. Vanjske poveznice i sponzori</h2>
              <p>
                Platforma može sadržavati poveznice na web stranice partnera,
                sponzora ili vanjskih organizatora. FucaScore nema kontrolu nad
                sadržajem tih stranica niti snosi odgovornost za njihove
                politike privatnosti ili uvjete korištenja.
              </p>
            </section>
          </div>
        </main>
      </div>
      <HomeFooter />
    </>
  );
};

export default TermsOfUse;
